import { InputDatePicker } from '@insurance/components'
import { Period } from '@insurance/components/Period'
import { useValidationsField } from '@insurance/hooks'
import { getEffectiveDateRange } from '@insurance/utils'
import { Col, Form, Row } from 'antd'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

import { usePropertyInsuranceValues } from './PropertyInsuranceContext'
import { formProps } from './utils'

const PERIOD_OPTIONS = [1, 1.5, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

const INSTALLMENTS_OPTIONS = [1, 2, 3, 4]

export const ValidFrom = () => {
  const { t } = useTranslation()
  const { validFromProps, periodProps, installmentsProps, effectiveDateProps } =
    formProps(t)
  const { required } = useValidationsField()
  const { isEditable, order } = usePropertyInsuranceValues()

  const periodOptions = PERIOD_OPTIONS.filter(
    (value) => typeof value === 'number'
  )
    .sort((a, b) => b - a)
    .map((value) => ({
      label: t(`m${value}`),
      value
    }))

  const installmentsOptions = INSTALLMENTS_OPTIONS.filter(
    (value) => typeof value === 'number'
  ).map((value) => ({
    label: t(`installment_${value}`),
    value
  }))

  const effectiveDateRange = getEffectiveDateRange(order)

  return (
    <Row gutter={[12, 12]}>
      <Col xs={24} lg={8}>
        {isEditable ? (
          <Form.Item {...effectiveDateProps} rules={[required]}>
            <InputDatePicker
              minDate={effectiveDateRange.minDate}
              maxDate={effectiveDateRange.maxDate}
              allowClear={false}
            />
          </Form.Item>
        ) : (
          <Form.Item {...validFromProps} rules={[required]}>
            <InputDatePicker
              minDate={dayjs?.()}
              placeholder={validFromProps.label}
            />
          </Form.Item>
        )}
      </Col>

      <Col xs={24} lg={16}>
        <Period
          periodDisabled={isEditable}
          installmentsDisabled={isEditable}
          periodProps={{ name: [periodProps.name], label: periodProps.label }}
          installmentsProps={{
            name: [installmentsProps.name],
            label: installmentsProps.label
          }}
          periodOptions={periodOptions}
          installmentsOptions={installmentsOptions}
        />
      </Col>
    </Row>
  )
}
